// lib/enhancedAuthenticatedFetch.ts
import { authenticatedFetch } from "./authenticatedFetch";
import {
  isPlanRestrictionError,
  PlanRestrictionError,
} from "./planRestrictionHandler";

export class PlanRestrictionAPIError extends Error {
  public readonly planRestriction: PlanRestrictionError;

  constructor(planRestriction: PlanRestrictionError) {
    super(
      `Plan restriction: ${planRestriction.message || `Access denied for ${planRestriction.feature}`}`,
    );
    this.planRestriction = planRestriction;
    this.name = "PlanRestrictionAPIError";
  }
}

export async function enhancedAuthenticatedFetch(
  input: RequestInfo,
  init: RequestInit = {},
): Promise<Response> {
  const response = await authenticatedFetch(input, init);

  // Check for plan restriction errors
  if (!response.ok) {
    const planRestriction = isPlanRestrictionError(response);
    if (planRestriction) {
      throw new PlanRestrictionAPIError(planRestriction);
    }
  }

  return response;
}
